"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleList = exports.StyleLine = exports.StyleErrorImg = exports.StyleError = exports.StyleCopiText = exports.StyleCopiImg = exports.StyleCopi = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleList = exports.StyleList = _styledComponents.default.ul.withConfig({
  displayName: "StyleList",
  componentId: "sc-k30vj1-0"
})(["padding:0 0 32px;font-size:1.2rem;white-space:nowrap;+ ul{padding-top:32px;font-size:1.4rem;text-transform:none;ul a{padding:11px 32px 10px 64px;}&:before{content:'';display:block;border-top:1px solid ", ";transform:translateY(-32px);}}ul div{padding:0px 8px 0px 16px;line-height:normal;p{margin-left:4px;font-family:Figtree;font-size:14px;font-style:normal;font-weight:400;line-height:120%;}&:hover{background-color:", ";}}"], (0, _color.default)('gray-2'), (0, _color.default)('gray-2'));
const StyleLine = exports.StyleLine = _styledComponents.default.i.withConfig({
  displayName: "StyleLine",
  componentId: "sc-k30vj1-1"
})(["position:absolute;left:0;top:0;width:4px;border-radius:8px;background-color:", ";transition:transform 0.2s;"], (0, _color.default)('primary'));
const StyleError = exports.StyleError = _styledComponents.default.div.withConfig({
  displayName: "StyleError",
  componentId: "sc-k30vj1-2"
})(["padding:0 32px;display:flex;align-items:center;font-size:1.2rem;cursor:", ";"], _ref => {
  let {
    onClick
  } = _ref;
  return onClick ? 'pointer' : 'default';
});
const StyleErrorImg = exports.StyleErrorImg = _styledComponents.default.img.withConfig({
  displayName: "StyleErrorImg",
  componentId: "sc-k30vj1-3"
})(["width:24px;height:24px;margin-right:16px;"]);
const StyleCopi = exports.StyleCopi = _styledComponents.default.div.withConfig({
  displayName: "StyleCopi",
  componentId: "sc-k30vj1-4"
})(["display:none;width:100%;margin-top:8px;@media ", "{cursor:pointer;display:flex;align-items:center;margin-left:4px;}"], _responsive.default.lg);
const StyleCopiImg = exports.StyleCopiImg = _styledComponents.default.div.withConfig({
  displayName: "StyleCopiImg",
  componentId: "sc-k30vj1-5"
})(["height:32px;width:32px;background-image:url('https://s3-sa-east-1.amazonaws.com/chatbot-droz/chatbot-droz-prod/attachment/6ad846650b18db3f68ec20569d9fa99e6c41b2ad/icon-minimized-20200720150415919-725.png');background-repeat:no-repeat;background-size:cover;margin:", ";"], _ref2 => {
  let {
    pinnedMenu,
    showPin
  } = _ref2;
  return pinnedMenu || showPin ? '0px 8px 0px 0px' : '0';
});
const StyleCopiText = exports.StyleCopiText = _styledComponents.default.div.withConfig({
  displayName: "StyleCopiText",
  componentId: "sc-k30vj1-6"
})(["display:", ";align-items:center;justify-content:center;position:relative;width:46%;background-color:", ";border-radius:4px;padding:4px 0px 8px 0px;color:#fff;font-family:Figtree;font-size:12px;font-style:normal;font-weight:700;line-height:120%;z-index:1;&::after{content:\"\";position:absolute;top:50%;right:100%;margin-top:-5px;border-width:5px;border-style:solid;border-color:transparent ", " transparent transparent;}"], _ref3 => {
  let {
    pinnedMenu,
    showPin
  } = _ref3;
  return pinnedMenu || showPin ? 'flex' : 'none';
}, (0, _color.default)('primary'), (0, _color.default)('primary'));